// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.logc-carousel-content[data-v-7db875d2] {\n    position: absolute;\n    top: 1px;\n    z-index: 1;\n}\n.logc-carousel-navigator[data-v-7db875d2] {\n    position: absolute;\n    bottom: 1px;\n    z-index: 2;\n}\n.logc-slider-text-position[data-v-7db875d2] {\n    position: absolute;\n    bottom: 10%;\n}\n.logc-slider-text-position-mobile[data-v-7db875d2] {\n    position: absolute;\n    bottom: 1px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
